import type { ReactNode } from 'react';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { Gavi } from '#components/mobile/travesia/Gavi';
import { color, texto } from '#components/mobile/ui/tokens';

import { tarjetaPlana } from './tarjetaPlana';

/** Una frase de Gavi en una tarjeta, arriba de la tripulación o de invitar. */
export function LineaGavi({ children }: { children: ReactNode }) {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        padding: '10px 12px',
        ...tarjetaPlana,
      }}
    >
      <View
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          backgroundColor: color.accentSoft,
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Gavi ancho={28} />
      </View>
      <Text
        style={{
          ...texto.secundario,
          fontWeight: 600,
          color: color.fg2,
          '& strong': { color: color.fg, fontWeight: 800 },
        }}
      >
        {children}
      </Text>
    </View>
  );
}
